// frontend/src/components/promotions/promotionDeleteCopy.js
//
// The delete confirmation's title and message for one promotion. A draft
// never ran, so deleting it undoes nothing; in Shopify an active or scheduled
// promotion also has prices to put back or cancel.

export function promotionDeleteCopy(promotion, isShopify, t) {
  const { name, status, items_count: count } = promotion;
  if (status === 'draft') {
    return { title: t('promotions.deleteTitle'), message: t('promotions.deleteDraftMessage', { name }) };
  }
  if (isShopify && status === 'active') {
    return {
      title: t('promotions.deleteActiveTitle'),
      message: t('promotions.deleteActiveMessage', { name, count }),
    };
  }
  if (isShopify && status === 'scheduled') {
    return {
      title: t('promotions.deleteScheduledTitle'),
      message: t('promotions.deleteScheduledMessage', { name, count }),
    };
  }
  return { title: t('promotions.deleteTitle'), message: t('promotions.deleteMessage', { name }) };
}
